
export default {
    Monthly: 'monthly_year',
    Peak: 'billing_6',
    Hourly: 'billing_hourly_title',
    Amount: 'mounty',
    Daily: 'billing_daily_title',
    DailyTry:'billing_try_title',
    Dailytry:'billing_try_title',
    RegionPeak:'diyu_bws',
    TrafficMonthly:'traffic_charge',
    PrepaidByTime:'amount_count',
    PostpaidByTime:'amount_after',
    HourlySettlement:'hour_monthly_net',
    HourlyInstantSettlement: 'kec-billtype-87',
    PostPaidByAdvanced95Peak: 'eip-billtype-807',
    DailyPaidByTransfer: 'daily_paid_by_transfer',
    null: '--',

    '预付费(包年包月)': 'monthly_year',
    '按月峰值付费(月结)': 'billing_6',
    '按小时配置付费（小时结）': 'billing_hourly_title',
    '按量先结': 'mounty',
    '按日配置付费(月结)': 'billing_daily_title',
    '地域共享带宽':'diyu_bws',
    '按月用量付费(月结)':'traffic_charge',
    '共享带宽':'bws_cn',
    '后付费(按次)':'amount_after',
    '预付费(按次)':'amount_count',
    '按小时配置付费(月结)':'hour_monthly_net',
    '您没有可移入共享带宽的计费方式,请联系售后':'noChargeType',
    '按日计费(试用)':'billing_try_title',
    '按小时配置实时付费': 'kec-billtype-87',
    '按量付费（月峰值）': 'billing_6',
    '按量付费（按日月结）': 'billing_daily_title',
    '按量付费': 'kec-billtype-87',
} as any;
